import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './i18nt/resources/en';
import sr from './i18nt/resources/sr';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      sr: { translation: sr },
    },
    lng: 'sr', // default language
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
